import {createOutboxCascade} from 'src/offline/pendingUploads';
import {FORM_OUTBOX_KINDS, formUploadRefs} from './localFiles';

/** A submission is one unit of work: the create plus the uploads queued with it. */
export const formSubmissionCascade = createOutboxCascade({
  kind: FORM_OUTBOX_KINDS.create,
  extractRefs: formUploadRefs,
});

/** Re-queues a failed submission and every failed upload it depends on. */
export const retryFormSubmission = formSubmissionCascade.retry;

/** Drops a queued submission with its unsynced uploads and captured blobs. */
export const discardFormSubmission = formSubmissionCascade.discard;
